import { Grid, Paper, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import * as R from 'ramda'
import React, { useEffect, useState } from 'react'
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip
} from 'recharts'
import {
  FonteLiberacaoColors,
  FonteLiberacaoLabelEnum
} from '../../Solicitacoes/components'
import slaRepository from '../SlaRepository'
import useQueryFilter from '../useQueryFilter'

const useStyles = makeStyles(theme => ({
  card: {
    padding: theme.spacing(2)
  }
}))

const COLORS = {
  [FonteLiberacaoLabelEnum.CENTRAL_CADASTROS]:
    FonteLiberacaoColors.CENTRAL_CADASTROS,
  [FonteLiberacaoLabelEnum.GESTOR]: FonteLiberacaoColors.GESTOR,
  [FonteLiberacaoLabelEnum.AUTOMATICAMENTE]:
    FonteLiberacaoColors.AUTOMATICAMENTE,
  [FonteLiberacaoLabelEnum.NAO_RECOMENDAR]: FonteLiberacaoColors.NAO_RECOMENDAR
}

export default function ChartSolicitacoesTotal(props) {
  const classes = useStyles()
  const [data, setData] = useState([])
  const [quantidade, setQuantidade] = useState()
  const [query, periodo] = useQueryFilter(props.location.search)
  useEffect(() => {
    async function fetchData(query) {
      if (query.dataInicio && query.dataFim) {
        const response = await slaRepository.solicitacoesTotal(
          query.dataInicio,
          query.dataFim,
          query.empresaId
        )
        if (response.ok) {
          let quantidade = 0
          setData(
            response.data.map(reg => {
              quantidade += parseInt(reg.count)
              return {
                fonteLiberacao: FonteLiberacaoLabelEnum[reg.fonteliberacao],
                count: parseInt(reg.count)
              }
            })
          )
          setQuantidade(quantidade)
        }
      }
    }
    if (!R.isEmpty(query)) {
      fetchData(query)
    } else {
      setData([])
    }
  }, [query])

  return (
    <Grid item xs={12} lg={4} sm={12}>
      <Paper className={classes.card}>
        <Typography variant="h6">
          Solicitações por fonte de liberação
        </Typography>
        <Typography variant="caption" display="block">
          Quantidade: {quantidade}
        </Typography>
        <Typography variant="caption">{periodo}</Typography>
        <ResponsiveContainer height={300}>
          <PieChart
            margin={{
              top: 20
            }}
          >
            <Tooltip />
            <Legend iconType="circle" />
            <Pie
              data={data}
              innerRadius={60}
              outerRadius={80}
              paddingAngle={5}
              nameKey="fonteLiberacao"
              dataKey="count"
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[entry.fonteLiberacao]}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </Paper>
    </Grid>
  )
}
